export const BASE_URL = '/api/';

/**
 * API Endpoints Configuration
 * 
 * IMPORTANT: Response Shape Compatibility
 * ========================================
 * - mobile_app_dashboard: Points to /deployment/apps which returns an ARRAY
 * - dashboard_data: Points to /appdata/dashboard which returns an OBJECT with allApps
 * 
 * TableComponent handles both response shapes automatically via an adapter pattern
 * (see TableComponent.tsx lines 460-490). The array response from /deployment/apps
 * is transformed into the flat object format that extractData() expects.
 * 
 * No breaking changes - both endpoints work seamlessly.
 */
export const API = {
    login_api: `${BASE_URL}login`,
    mobile_app_dashboard: `${BASE_URL}deployment/apps`,  // Returns array - auto-converted to flat object
    dashboard_data: `${BASE_URL}appdata/dashboard`,  // Returns object with allApps property
    trigger: `${BASE_URL}appdata/trigger`,
    recent_pipelines: `${BASE_URL}appdata/get-pipelines`,
    update_activity: `${BASE_URL}appdata/activity`,
    release_notes: `${BASE_URL}release-notes`,
};
